import React from 'react';
import styled from 'styled-components';
import {Select} from 'antd';

import {IRaiseSelectProps} from './RaiseSelect.types';
import {margins} from '../commonProps';

const RaiseSelect = styled(
  ({
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
    margin,
    ...props
  }: IRaiseSelectProps) => <Select {...props} />,
)`
  && {
    ${margins}
    width: 100%;
    .ant-select-selector {
      width: 100%;
      border-radius: 7px;
      font-family: 'Poppins', sans-serif;
      font-size: 16px;
    }
  }
`;

export default RaiseSelect;
